<div class="heading-tab">
  <h3 class="heading"><i nz-icon nzType="file-text"></i> Product Details</h3>
</div>
<form [formGroup]="claimsBasicDetailsForm">
  <div class="tab-grid m-t-20">


    <!-- start product component -->
    <nz-form-item>
      <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('receivedDt')">Product</nz-form-label>
      <nz-form-control [nzSpan]="24">
        <!-- <nz-date-picker id="receivedDt" formControlName="receivedDt" nzShowTime [nzFormat]="'DD MMM yyyy'">
                      </nz-date-picker> -->
        <nz-select nzShowSearch [nzSize]="" formControlName="productType">
          <!-- <nz-option *ngFor="let option of listOfOption" [nzLabel]="option.label" [nzValue]="option.value"></nz-option> -->
          <nz-option [nzLabel]="">option1</nz-option>
          <nz-option [nzLabel]="">option2</nz-option>
          <nz-option [nzLabel]="">option3</nz-option>
        </nz-select>
        <!-- <nz-form-explain
                        *ngIf="(claimsBasicDetailsForm.get('receivedDt').dirty || claimsBasicDetailsForm.get('receivedDt').touched) && claimsBasicDetailsForm.get('receivedDt').errors">
                        <p style="color:red"
                          *ngFor="let error of validationUtilService.getUIErrorList(claimsBasicDetailsForm.get('receivedDt'), CLAIMSBASICDETAILSFORMNAME)">
                          {{error}}</p>
                      </nz-form-explain> -->
      </nz-form-control>
    </nz-form-item>
    <!-- end product component -->

    <!-- start plan type component -->

    <nz-form-item>
      <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('receivedDt')">Plan type</nz-form-label>
      <nz-form-control [nzSpan]="24">
        <!-- <nz-date-picker id="receivedDt" formControlName="receivedDt" nzShowTime [nzFormat]="'DD MMM yyyy'">
            </nz-date-picker> -->
        <nz-select nzShowSearch [nzSize]="" formControlName="planType">
          <!-- <nz-option *ngFor="let option of listOfOption" [nzLabel]="option.label" [nzValue]="option.value"></nz-option> -->
          <nz-option [nzLabel]="">option1</nz-option>
          <nz-option [nzLabel]="">option2</nz-option>
          <nz-option [nzLabel]="">option3</nz-option>
        </nz-select>
        <!-- <nz-form-explain
              *ngIf="(claimsBasicDetailsForm.get('receivedDt').dirty || claimsBasicDetailsForm.get('receivedDt').touched) && claimsBasicDetailsForm.get('receivedDt').errors">
              <p style="color:red"
                *ngFor="let error of validationUtilService.getUIErrorList(claimsBasicDetailsForm.get('receivedDt'), CLAIMSBASICDETAILSFORMNAME)">
                {{error}}</p>
            </nz-form-explain> -->
      </nz-form-control>
    </nz-form-item>

    <!-- end plan type component -->

    <!-- start Policy type component -->

    <nz-form-item>
      <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('receivedDt')">Policy Type - Individual/Floater
      </nz-form-label>
      <nz-form-control [nzSpan]="24">
        <!-- <nz-date-picker id="receivedDt" formControlName="receivedDt" nzShowTime [nzFormat]="'DD MMM yyyy'">
              </nz-date-picker> -->
        <nz-select nzShowSearch [nzSize]="" formControlName="policyType">
          <!-- <nz-option *ngFor="let option of listOfOption" [nzLabel]="option.label" [nzValue]="option.value"></nz-option> -->
          <nz-option [nzLabel]="">option1</nz-option>
          <nz-option [nzLabel]="">option2</nz-option>
          <nz-option [nzLabel]="">option3</nz-option>
        </nz-select>
        <!-- <nz-form-explain
                *ngIf="(claimsBasicDetailsForm.get('receivedDt').dirty || claimsBasicDetailsForm.get('receivedDt').touched) && claimsBasicDetailsForm.get('receivedDt').errors">
                <p style="color:red"
                  *ngFor="let error of validationUtilService.getUIErrorList(claimsBasicDetailsForm.get('receivedDt'), CLAIMSBASICDETAILSFORMNAME)">
                  {{error}}</p>
              </nz-form-explain> -->
      </nz-form-control>
    </nz-form-item>
    <!-- end Policy type component -->


    <!-- start sum insured component -->

    <nz-form-item>
      <nz-form-label [nzSpan]="24" nzRequired nzFor="name"> Sum Insured</nz-form-label>
      <nz-form-control [nzSpan]="24" nzErrorTip="Please input your name">
        <input type="text" nz-input formControlName="sumInsured" placeholder="Sum Insured" />
      </nz-form-control>
    </nz-form-item>

    <!-- end sum insured component -->
    <!-- start Policy Start Date component -->
    <nz-form-item>
      <nz-form-label nzFor="eventDate" [nzSpan]="24" [nzRequired]="isRequired('eventDate')">Policy Start Date
        <!--(Date of Death)-->
      </nz-form-label>
      <nz-form-control [nzSpan]="24">
        <nz-date-picker id="eventDate" formControlName="eventDate" style="width:100%" [nzFormat]="'DD MMM yyyy'"
          (ngModelChange)="onChange($event,'EVENT')">
        </nz-date-picker>
        <!--  -->
        <nz-form-explain
          *ngIf="(claimsBasicDetailsForm.get('eventDate').dirty || claimsBasicDetailsForm.get('eventDate').touched) && claimsBasicDetailsForm.get('eventDate').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(claimsBasicDetailsForm.get('eventDate'), CLAIMSBASICDETAILSFORMNAME)">
            {{error}}</p>
        </nz-form-explain>
        <!-- 
        <small class="d-b">Retype Event Date</small>
        <nz-form-control [nzSpan]="24">
          <nz-date-picker id="retypeEventDate" formControlName="retypeEventDate" style="width:100%"
            [nzFormat]="'DD MMM yyyy'" (ngModelChange)="onChange($event,'RETYPE')">
          </nz-date-picker>
          <nz-form-explain *ngIf="isdateValid == false">
            <p style="color:red">
              Event date and retype event date mismatch
            </p>
          </nz-form-explain>

        </nz-form-control> -->
      </nz-form-control>
    </nz-form-item>
    <!-- end Policy Start Date component -->


    <!-- Start Policy Expiry Date Date component -->

    <nz-form-item>
      <nz-form-label nzFor="eventTime" [nzSpan]="24" [nzRequired]="isRequired('eventTime')">Policy Expiry Date
        <!--(Time of Death)-->
      </nz-form-label>
      <nz-form-control [nzSpan]="24">
        <nz-date-picker id="eventTime" formControlName="eventTime" style="width:100%" [nzFormat]="'HH:mm'"
          (ngModelChange)="onTimeChange($event,'EVENT')">
        </nz-date-picker>
        <nz-form-explain
          *ngIf="(claimsBasicDetailsForm.get('eventTime').dirty || claimsBasicDetailsForm.get('eventTime').touched) && claimsBasicDetailsForm.get('eventTime').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(claimsBasicDetailsForm.get('eventTime'), CLAIMSBASICDETAILSFORMNAME)">
            {{error}}</p>
        </nz-form-explain>

        <!-- <small class="d-b">Retype Time</small>
        <nz-form-control [nzSpan]="24">
          <nz-time-picker id="retypeEventTime" formControlName="retypeEventTime" style="width:100%" [nzFormat]="'HH:mm'"
            (ngModelChange)="onTimeChange($event,'RETYPE')">
          </nz-time-picker>

          <nz-form-explain *ngIf="timeCheck == false">
            <p style="color:red">
              Event time and retype event time mismatch
            </p>
          </nz-form-explain>
        </nz-form-control> -->
      </nz-form-control>
    </nz-form-item>
    <!-- end Policy Expiry Date Date component -->

    <nz-form-item>
      <nz-form-label [nzSpan]="24">Durations
      </nz-form-label>
      <nz-form-control [nzSpan]="24">
        <p>34 days</p>

      </nz-form-control>
    </nz-form-item>
    <!-- end Cover Type  component -->

    <!-- start Cover Type  component -->



  </div>


  <app-coverages></app-coverages>
  <!-- <ui-multirow-basic type="phone"
    [inputDataForEdit]="inputClientCaptureEmailDetailsList"></ui-multirow-basic>

 -->

  <!-- Dates -->
  <div class="tab-grid">
    <!-- start portability  component -->
    <nz-form-item class="portability">
      <label nz-checkbox formControlName="portability"></label>
      <nz-form-label [nzSpan]="20" nzRequired nzFor="name">Are you applying for portability</nz-form-label>
    </nz-form-item>

    <!-- end portability  component -->
  </div>
</form>